import { SignupGuardRule } from '@/pages/signup/signup-guard';

// Guard rules for the onboarding iPhone-mockup flow (/onboarding/*).
// Mirrors the pattern in `signup-guard-rules.ts`, reusing the same
// `SignupGuard`/`SignupGuardRule` types unmodified.

export const ruleStageIsWaitingForInfo: SignupGuardRule = {
  check: (tcr) => tcr.stage === 'waiting-for-info',
  redirectTo: '../complete',
};

export const ruleStageIsLeadOnboarded: SignupGuardRule = {
  check: (tcr) => tcr.stage === 'lead-onboarded',
  redirectTo: '../choose-store',
};

export const ruleHasStorePlatform: SignupGuardRule = {
  check: (tcr) => tcr.storePlatform !== null,
  redirectTo: '../choose-store',
};

export const ruleHasAppIdentity: SignupGuardRule = {
  check: (tcr) => !!tcr.appName && !!tcr.storeUrl,
  redirectTo: '../app-name-link',
};

export const ruleHasAppLogo: SignupGuardRule = {
  check: (tcr) => tcr.appIconUrl !== null,
  redirectTo: '../app-logo',
};

export const ruleHasAtLeastOneTab: SignupGuardRule = {
  check: (tcr) => tcr.tabs.length >= 1,
  redirectTo: '../tab-bar',
};
